export const QUEST_CONFIG: Record<number, string> = {
  1: "Bridge $100 to Berachain",
  2: "Stake at least $100 in Vaults",
  3: "Check your portfolio page",
  4: "Make a swap on Superswap",
  5: "Stake at least $10 for BERA",
  6: "Stake at least $10 for iBGT",
  7: "Complete 1 daily check-in",
  8: "Play 1 Carnival game",
  9: "Swap $100+ in $HENLO on Kodiak",
  10: "Share Beratown on X",
  11: "Invite a new user and need him to complete a transaction",
};
